import React from 'react';

const FAQ = () => {
    return (
        <div>
            faq
        </div>
    );
};

export default FAQ;